import * as React from 'react'

import { getConfigBySite } from '../../../config/sites'
import AutoSuggest from '../../components/autosuggest/autosuggest'
import createAutoSuggestDataContainer from '../../components/autosuggest/autoSuggestDataContainer'
import createAutoSuggestLogicContainer from '../../components/autosuggest/autoSuggestLogicContainer'
import SearchHeader from '../../components/searchHeader/searchHeader'
import SeoHeadings from '../../components/seoHeadings/seoHeadings'
import CommunitySection from './communitySection'
import FeaturedItemsSection from './featuredItemsSection'
import FreeItemSection from './freeItemSection'
import MarketingSection from './marketingSection'
import NewestItemSection from './newestItemSection'

import PageSection from './pageSection'
import TutorialsSection from './tutorialsSection'

import * as autoSuggestStyles from '../../components/autosuggest/themes/homepage.module.css'
import * as searchHeaderStyles from '../../components/searchHeader/themes/homepage.module.css'
import * as seoHeadingsStyles from '../../components/seoHeadings/themes/homepage.module.css'
import * as styles from './homePage.module.css'

import { Props } from '../../containers/homePageContainer'

const AutoSuggestContainer = createAutoSuggestDataContainer(
  createAutoSuggestLogicContainer(AutoSuggest)
)

const HomePage = ({
  location,
  currentSite,
  isSignedIn,
  metadata,
  newestItemsData,
  featuredItems,
  fetchNewestItemsByCategory,
  preferences,
  muteVideo
}: Props) => {
  return (
    <div>
      <div className={styles.searchHeaderSection}>
        <SearchHeader currentSite={currentSite} styles={searchHeaderStyles}>
          <SeoHeadings
            TagName="h1"
            heading="38,385 WordPress Themes & Website Templates From $2"
            subHeading="WordPress themes, web templates and more. Brought to you by the largest global community of creatives."
            styles={seoHeadingsStyles}
          />
          <AutoSuggestContainer
            inputName="term"
            value=""
            placeholder={getConfigBySite(
              currentSite,
              'home_search_placeholder'
            )}
            currentSite={currentSite}
            location={location}
            styles={autoSuggestStyles}
            showCategories={true}
          />
        </SearchHeader>
      </div>

      {metadata && (
        <FeaturedItemsSection
          items={featuredItems.slice(0, 10)}
          metadata={metadata.featured_items}
          muteVideo={muteVideo}
          videoMuted={preferences.searchVideoMuted}
        />
      )}

      {newestItemsData.items &&
        metadata && (
          <PageSection>
            <NewestItemSection
              currentSite={currentSite}
              fetchNewestItemsByCategory={fetchNewestItemsByCategory}
              metadata={metadata.newest_items}
              newestItemsData={newestItemsData}
              muteVideo={muteVideo}
              videoMuted={preferences.searchVideoMuted}
            />
          </PageSection>
        )}

      {newestItemsData.items &&
        metadata && (
          <PageSection borderTop>
            <FreeItemSection
              isSignedIn={isSignedIn}
              items={newestItemsData.items.slice(0, 6)}
              metadata={metadata.free_items}
              muteVideo={muteVideo}
              videoMuted={preferences.searchVideoMuted}
            />
          </PageSection>
        )}

      {metadata && (
        <PageSection borderTop spaceBottom>
          <MarketingSection blocks={metadata.marketing_blocks} />
        </PageSection>
      )}

      {metadata && (
        <PageSection borderTop darkBackground>
          <CommunitySection metadata={metadata.community} />
        </PageSection>
      )}

      {metadata && (
        <PageSection>
          <TutorialsSection metadata={metadata.tutorials} />
        </PageSection>
      )}
    </div>
  )
}

export default HomePage



// WEBPACK FOOTER //
// ./client/pages/home/homePage.tsx